/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './loader-root.html';

import LoaderContainer from './loader-container';

export default defineComponent({
  name: 'LoaderRoot',
  template,
  components: { LoaderContainer },
  emits: {},
  props: {
    animate: { type: Boolean, required: false, default: false }
  }
});
